import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect, getReleased } from "./redux/blockchain/blockchainActions";
import { deploy } from "./redux/blockchain/blockchainActions";
import { getInfo } from "./redux/blockchain/blockchainActions";
import { getShare} from "./redux/blockchain/blockchainActions";
import { updateAddressesFromFirebase } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";

import * as s from "./styles/globalStyles";
import styled from "styled-components";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ComboBox from 'react-responsive-combo-box'
import 'react-responsive-combo-box/dist/index.css'


const truncate = (input, len) =>
  input.length > len ? `...${input.substring(input.length - len, input.length)}` : input;

export const StyledButton = styled.button`
  padding: 10px;
  border-radius: 50px;
  border: none;
  width: 15%;
  background-color: var(--secondary);
  padding: 10px;
  font-weight: bold;
  color: var(--secondary-text);
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;
export const StyledButton2 = styled.button`
  padding: 10px;
  border-radius: 20px;
  border: none;
  background-color: var(--secondary);
  padding: 10px;
  margin: 5px;
  font-weight: bold;
  font-size: large;
  width: 250px;
  margin-left: 38%;
  color: var(--secondary-text);
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;
export const StyledButton3 = styled.button`
  padding: 10px;
  border-radius: 20px;
  border: none;
  background-color: var(--secondary);
  padding: 10px;
  font-weight: bold;
  font-size: large;
  margin: 10px;
  width: 80%;
  margin-left: 10%;
  color: var(--secondary-text);
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;
export const StyledRoundButton = styled.button`
  padding: 10px;
  border-radius: 100%;
  border: none;
  background-color: var(--primary);
  padding: 10px;
  font-weight: bold;
  font-size: large;
  font-size: 15px;
  color: var(--primary-text);
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;
  @media (min-width: 767px) {
    flex-direction: row;
  }
`;

export const StyledLogo = styled.img`
  width: 200px;
  @media (min-width: 767px) {
    width: 300px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
`;

export const StyledImg = styled.img`
  box-shadow: 0px 5px 11px 2px rgba(0, 0, 0, 0.7);
  border: 4px dashed var(--secondary);
  background-color: var(--accent);
  border-radius: 100%;
  width: 200px;
  @media (min-width: 900px) {
    width: 250px;
  }
  @media (min-width: 1000px) {
    width: 300px;
  }
  transition: width 0.5s;
`;

export const StyledLink = styled.a`
  color: var(--secondary);
  font-weight: bold;
  text-decoration: none;
  text-underline-position: under;
  text-decoration: underline;
  font-size: 30px;
`;
export const StyledLink2 = styled.a`
  color: var(--secondary);
  font-weight: bold;
  text-decoration: none;
  text-underline-position: under;
  text-decoration: underline;
  font-size: 20px;
`;

function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [feedback, setFeedback] = useState(`Enter address and share information to generate a split contract.`);
  const [searchButton, setSearchButton] = useState(`Search`);
  const [addresses, setAddresses] = useState(``);
  const [formFields, setFormFields] = useState([
    { address: '', share: '' },
    { address: '', share: '' },
    { address: '', share: '' },
  ])
  const [buttonFields, setButtonFields] = useState([
    { address: ''},
  ])
  const [inputText, setInputText] = useState("");

  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    TOKEN_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: "?",
    WEI_COST: "?",
    DISPLAY_COST: "?",
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });


  var options = []
  
  const updateAddresses = () => { 
    if(data.addresses.length != options.length){
    options.splice(0, options.length)
    for (let i = 0; i < data.addresses.length; i++) {
      options.push(data.addresses[i])
    }
    }
  }

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);


  useEffect(() => {
    getInfo(inputText);
  }, []);
  
  useEffect(() => {
    updateAddressesFromFirebase();
  }, [data.addresses]);

  

  const handleFormChange = (event, index) => {
    let data2 = [...formFields];
    data2[index][event.target.name] = event.target.value;
    setFormFields(data2);

  }
  const submit = (e) => {
    e.preventDefault();
  }
  const submit2 = (e) => {
    e.preventDefault();
    var check = false;
    var check100 = 0;
    for (let i = 0; i < formFields.length; i++) {
      if (formFields[i].address == '' || !isAddress(formFields[i].address.toLowerCase()) || formFields[i].share == ''){
        check = true;
      }
      check100 += Number(formFields[i].share);
    }
    if(!check && check100 == 100){
      dispatch(deploy(formFields));
      document.getElementById('main').setAttribute("class", "main2");
      document.getElementById('deploy').setAttribute("class", "main");
    } else if (check){
      toast.error('Please recheck the input fields.', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark"
      });
    } else if (check100 != 100){
      toast.error('Shares must add up to 100.', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark"
      });
    }
  }
  var isAddress = function (address) {
    if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) {
      return false;
    } else if (/^(0x)?[0-9a-f]{40}$/.test(address) || /^(0x)?[0-9A-F]{40}$/.test(address)) {
      return true;
    } 
  }
  const submit3 = (e) => {
    if(searchButton == "Search again"){
      document.getElementById('search').setAttribute("class", "search");
      setSearchButton("Search");
      document.getElementById('search2').setAttribute("class", "search");
      document.getElementById('search3').setAttribute("class", "search2");
      document.getElementById('search4').setAttribute("class", "search");
      document.getElementById('searchCombobox').setAttribute("class", "combobox2");
    }else{
      if (isAddress(inputText)) {
        document.getElementById('searchCombobox').setAttribute("class", "combobox");
        dispatch(getInfo(inputText));
        document.getElementById('search').setAttribute("class", "search2");
        setSearchButton("Search again");
      } else {
        document.getElementById('search').setAttribute("class", "search");
        toast.error('Please enter a correct address.', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark"
        });
    }
    
    }
    if (buttonFields.length > 1) {
      removeButtons();
    }
  }

  const submit4 = (e) => {
    addButtons(); 

    document.getElementById('search2').setAttribute("class", "search2");
    document.getElementById('search3').setAttribute("class", "search");
  }
  
  const addFields = () => {
    if(formFields.length < 10){
    let object = {
      address: '',
      share: ''
    }
    setFormFields([...formFields, object])
  }
  }
  const addButtons = () => {
    if (buttonFields.length<2){
      let data3 = [...buttonFields];
      data3.splice(0, 1)

      for (let i = 0; i < data.payees.length; i++) {

        data3.push(data.payees[i])
      }

      setButtonFields(data3)
    }
  }
  const removeButtons = () => {
    if (buttonFields.length > 1) {
      let data3 = [...buttonFields];
      data3.splice(0, buttonFields.length)
      setButtonFields(data3)
    }
  }
  let inputHandler = (option) => {
    var lowerCase = option.toLowerCase();
    setInputText(lowerCase);
  };
  let inputHandler2 = (input) => {
    var lowerCase = input.toLowerCase();
    setInputText(lowerCase);
  };

  const removeFields = (index) => {
    if(formFields.length > 1){
    let data3 = [...formFields];
    data3.splice(index, 1)
    setFormFields(data3)
  }
  }
  const showInfo = (index) => {
    dispatch(getShare(inputText,data.payees[index]));
    document.getElementById('search4').setAttribute("class", "search2");
  }
  
  const mainScreen = () => {
    dispatch(updateAddressesFromFirebase())
    document.getElementById('main').setAttribute("class", "main");
    document.getElementById('deploy').setAttribute("class", "main2");

  }

  

  return (
    <s.Screen>
      <s.Container
        flex={1}
        ai={"center"}
        style={{ padding: 24, backgroundColor: "var(--primary)" }}
        image={CONFIG.SHOW_BACKGROUND ? "/config/images/bg.png" : null}
      >
        <StyledLogo alt={"logo"} src={"/config/images/logo2.png"} />
        <s.SpacerSmall />
        <ResponsiveWrapper flex={1} style={{ padding: 24 }} test>
          
          <s.SpacerLarge />
          <s.Container
            flex={2}
            jc={"center"}
            ai={"center"}
            style={{
              backgroundColor: "var(--accent)",
              padding: 24,
              opacity: "80%",
              borderRadius: 24,
              border: "4px solid var(--secondary)",
              boxShadow: "0px 5px 11px 2px rgba(0,0,0,0.7)",
            }}
          >
            
              <>
                
                {blockchain.account === "" ||
                blockchain.smartContract === null ? (
                  <s.Container ai={"center"} jc={"center"}>
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                       <s.SpacerMedium />
                   
                    <s.SpacerSmall />
                      Connect to the {CONFIG.NETWORK.NAME} network
                    </s.TextDescription>
                    <s.SpacerSmall />
                    <StyledButton
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(connect());
                        getData();
                        
                      }}
                    >
                      CONNECT
                    </StyledButton>
                    {blockchain.errorMsg !== "" ? (
                      <>
                        <s.SpacerSmall />
                        <s.TextDescription
                          style={{
                            textAlign: "center",
                            color: "var(--accent-text)",
                          }}
                        >
                          {blockchain.errorMsg}
                        </s.TextDescription>
                      </>
                    ) : null}
                  </s.Container>
                ) : (
                  <>

                  <div id="main">
                    <StyledLink target={"_blank"} href={`https://rinkeby.etherscan.io/address/${data.account}`}>
                      Your wallet address: {data.account}
                    </StyledLink>
                <s.SpacerXSmall />
                    <s.SpacerMedium />

                <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      {feedback}
                    </s.TextDescription>
                    <s.SpacerMedium />
                <s.SpacerXSmall />
               
                  
                  
                    <s.TextDescription
                    style={{
                    textAlign: "center",
                    color: "var(--primary-text)",
                    }}
            >
            <s.SpacerMedium />
            <s.SpacerMedium />
                        </s.TextDescription>

            <form onSubmit={submit}>
              {formFields.map((form, index) => {
                return (
                  <div key={index}>
                    <input
                      className="field"
                      name='address'
                      placeholder='Address'
                      onChange={event => handleFormChange(event, index)}
                      value={form.address}
                    />
                    <input
                      className="field2"
                      name='share'
                      placeholder='Share'
                      onChange={event => handleFormChange(event, index)}
                      value={form.share}
                    />
                    <StyledButton onClick={() => removeFields(index)}>Remove</StyledButton>
                  </div>
                )
              })}
            </form>
                    
                    <br />  
                    <br />  
                          <StyledButton2 onClick={addFields}>Add address</StyledButton2>
                          <br />  
                          <br />
                          <StyledButton2 onClick={submit2}>Deploy Contract</StyledButton2>
                          <br />       
                          <br />  
                         
                    <s.TextTitle
                      style={{
                        textAlign: "center",
                        fontSize: 30,
                        fontWeight: "bold",
                        color: "var(--accent-text)",
                      }}
                    >
                      Split Contract Search
                    </s.TextTitle>
                    <div id="searchCombobox" onClick={() => updateAddresses()}>      
                    <ComboBox
                      options={options}
                      placeholder="Contract address"
                      defaultIndex={4}
                      type="text"
                      className="field3"
                      id="addressInput"
                      optionsListMaxHeight={200}
                      popoverClassName='combo-box-popover'

                      style={{
                        width: "90%",
                        margin: "5px",
                        marginTop: "20px",
                        marginLeft: "5%",
                        backgroundColor: "white",
                        borderColor: "aqua",
                        padding: "10px",
                        borderRadius: "20px"
                      }}
                      //focusColor="#20C374"
                      renderOptions={(option) => (
                        <div className="comboBoxOption">{option}</div>
                      )}
                      onSelect={(option) => inputHandler(option)}
                      onChange={(event) => inputHandler2(event.target.value)}
                      enableAutocomplete
                    />
                    </div>
                    <br />  
                      <StyledButton2 onClick={() => submit3()}>{searchButton}</StyledButton2>
                    <br />  

                    <div id="search" className="search" >
                      

                      <s.TextTitle
                        style={{
                          textAlign: "center",
                          fontSize: 20,
                          fontWeight: "bold",
                          color: "var(--accent-text)",
                        }}
                      >
                        Contract: {truncate(inputText,6)}
                      </s.TextTitle>       
                      <s.TextTitle
                        style={{
                          textAlign: "center",
                          fontSize: 20,
                          fontWeight: "bold",
                          padding: "5px",
                          color: "var(--accent-text)",
                        }}
                      >
                        Total released: {data.totalReleased / 1000000000000000000} ETH

                      </s.TextTitle>
                      <div id="search3" className="search2" >
                      <StyledButton3 className="field4" onClick={() => submit4()}>Click here to see payee details.</StyledButton3>
                      </div>
                      <div id="search2" className="search" >
                  
                      <form onSubmit={submit}>
                        {buttonFields.map((form, index) => {
                          return (
                            <div key={index}>
                              <StyledButton3
                                className="field4"
                                name='address'
                                value={form.address}
                                onClick={() => showInfo(index)}>{data.payees[index]}</StyledButton3>
                            </div>
                          )
                        })}
                      </form>
                          <div id="search4" className="search" >

                          <s.TextTitle
                            style={{
                              textAlign: "center",
                              fontSize: 20,
                              fontWeight: "bold",
                              color: "var(--accent-text)",
                            }}
                          >
                            Share: {data.share}%

                          </s.TextTitle>
                          <s.TextTitle
                            style={{
                              textAlign: "center",
                              fontSize: 20,
                              fontWeight: "bold",
                              color: "var(--accent-text)",
                            }}
                          >
                            Released: {data.released / 1000000000000000000} ETH

                          </s.TextTitle>
                          
                            </div>
                      </div>
                    </div>
                    
              <s.SpacerXSmall />

                   
                    </div>
                    <div id="deploy" className="main2">
                      <s.TextDescription
                        style={{
                          textAlign: "center",
                          color: "var(--primary-text)",
                        }}
                      >
                        Please proceed with wallet.
                      </s.TextDescription>
                      <s.TextDescription
                        style={{
                          textAlign: "center",
                          color: "var(--primary-text)",
                        }}
                      >
                        Make sure you are connected to the right network.
                      </s.TextDescription>

                      <br />  

                      <br />  

                      <StyledLink2 target={"_blank"} href={`https://rinkeby.etherscan.io/address/${data.deployedContract}`}>
                        Deployed contract address: {data.deployedContract}
                      </StyledLink2>
                      <br />  

                      <s.SpacerMedium />
                      <StyledButton3
                        onClick={() => mainScreen()}>Done</StyledButton3>
                    </div>
                  </>
                  
                )}
                
              </>
            
            <s.SpacerMedium />
          </s.Container>
          <s.SpacerLarge />
          
        </ResponsiveWrapper>
        <s.SpacerMedium />
        <s.Container jc={"center"} ai={"center"} style={{ width: "70%" }}>
          <s.TextDescription
            style={{
              textAlign: "center",
              color: "var(--primary-text)",
            }}
          >
            Please make sure you are connected to the right network (
            {CONFIG.NETWORK.NAME} Network) and the correct address. 
          </s.TextDescription>
          <s.SpacerSmall />
          <ToastContainer
                  className="foo" style={{ padding: "20px", width: "auto"}}
                  position="top-center"
                  closeButton={false}      
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  limit={3}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                        />
          <s.TextDescription
            style={{
              textAlign: "center",
              color: "var(--primary-text)",
            }}
          >
            
          </s.TextDescription>
        </s.Container>
      </s.Container>
    </s.Screen>
  );
}

export default App;
